// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3eR32","title":"InfoRow_title__2BpVY"};